
import { useQueryClient } from "@tanstack/react-query";
import { notificacion, notificacionError } from "../../../../components/Alerts";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "../../../../components/modals/BaseModal";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import type { Respuesta } from "../../../../ts/typings/clases";

interface ModalEnviarPedidoProps extends BaseModalProps {
	readonly pedidosMarcados: Record<string, boolean>;
}
export function ModalEnviarPedidos(props: ModalEnviarPedidoProps) {
	const pedidos = Object.entries(props.pedidosMarcados).filter(([_id, marcado]) => marcado).map(([id]) => parseInt(id));
	const queryClient = useQueryClient();

	const onConfirmarEnvio = () => {
		void traspasarPedidos(pedidos)
			.then(success => {
				void queryClient.invalidateQueries({ queryKey: ["getCiclos"] });
				if (success) props.close();
			});
	};

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h5 className="modal-title"> Marcar pedidos como enviados</h5>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body" style={{ textAlign: "center" }}>
				{/* <h3>Fecha de envio</h3>
				<input style={{ marginBottom: 15 }} id="xfecha_envio" type="date" /> */}
				Está a punto de marcar {pedidos.length} pedido(s) como enviados. ¿Desea continuar?
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
				<button type="button" className="btnPrimary" onClick={onConfirmarEnvio}>Enviar</button>
			</div>
		</BaseModal>
	);
}

async function traspasarPedidos(idsPedidos: number[]) {
	const response = await ComunicacionAjax.sendAjaxRequest<Respuesta>("POST", "/enviarPedidos", {
		"idsPedidos": idsPedidos,
	});

	if (response.tipo == "exito") {
		notificacion(response.message ?? "Pedidos marcados como enviados.");
		return true;
	} else {
		notificacionError(response.message ?? "Error al enviar los pedidos.");
		return false;
	}
}